import { FC } from "react"
import styled from "@emotion/styled"

export const ListItem = styled.li`
  all: unset;
  display: block;
`
